/**
 * 📦 V2 Coupons API client
 * Rotas /api/v2/coupons
 */

import v2Api from './index';

export const couponsV2API = {
  /**
   * Cria cupom.
   * Body: { product_id, user_id, code, target_type, target_id,
   *         discount_type, discount_percent | discount_cents, valid_from?, valid_until?,
   *         max_uses?, is_active? }
   */
  create: (data) => v2Api.post('/coupons', data),

  /** Lista cupons de um produto. */
  listByProduct: (productId) => v2Api.get(`/coupons/by-product/${productId}`),

  findById: (id) => v2Api.get(`/coupons/${id}`),

  update: (id, data) => v2Api.patch(`/coupons/${id}`, data),

  remove: (id) => v2Api.delete(`/coupons/${id}`),

  /**
   * Preview de aplicação (sem registrar uso). Útil em checkout.
   * Body: { code, product_id, plan_id, total_amount_cents, customer_email }
   */
  validate: (data) => v2Api.post('/coupons/validate', data),
};

export default couponsV2API;
